import React, { memo, useEffect } from "react";
import makeStyles from "@material-ui/styles/makeStyles";
import { useSelector, useDispatch } from "react-redux";
import { clearVehiculoAnio, setVehiculoAnio } from "../actions";
import VehiculoAnioSelector from "~business/vehiculoAnioSelector/VehiculoAnioSelector";
import MulticotizadorContent from "./MulticotizadorContent";
import PrimaryTitle from "~styled/primaryTitle/PrimaryTitle";

const useStyles = makeStyles((theme) => ({
  title: {
    paddingBottom: "16px",
  },
}));

const useReduxSelector = () =>
  useSelector((state) => ({
    anioSelected: state.multicotizadorReducer.anioSelected,
  }));

const AnioStep = memo(() => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { anioSelected } = useReduxSelector();

  useEffect(() => {
    dispatch(clearVehiculoAnio());
  }, [dispatch]);

  const handleChange = (event) => {
    dispatch(
      setVehiculoAnio({
        label: event.target.value,
        value: event.target.value,
      })
    );
  };

  return (
    <>
      <MulticotizadorContent>
        <div className={classes.title}>
          <PrimaryTitle
            label="Ingresá el año del vehículo del asegurado"
            marginBottom={32}
          />
        </div>
        <VehiculoAnioSelector value={anioSelected} onChange={handleChange}/>
      </MulticotizadorContent>
    </>
  );
});

export default AnioStep;
